// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster'

async function submit(values, dispatch) {

  const query = `
    query(
    $id: Int,
    $paymentName: String,
    $paymentStatus: String,
    $paymentMode: String,
    $email: String,
    $APIUserId: String,
    $APIPassword: String,
    $APISecret: String,
    $AppId: String
    ){
    updatePaymentSettings(
        id: $id,
        paymentName: $paymentName,
        paymentStatus: $paymentStatus,
        paymentMode: $paymentMode,
        email: $email,
        APIUserId: $APIUserId,
        APIPassword: $APIPassword,
        APISecret: $APISecret,
        AppId: $AppId
    ) {
        status
    }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updatePaymentSettings?.status === "success") {
    showToaster({ messageId: 'paymentSettingsUpdate', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'paymentSettingsUpdateFailed', toasterType: 'error' })
  }

}

export default submit;
